/*  */

import slugg from 'slugg';
import { matchPath } from 'react-router';

const isMatch = function isMatch(location) {
  const match = matchPath(location.pathname || location, this.pattern);

  return (match && match.isExact) || false;
};

const slugifyPaths = paths =>
  paths.map(p => slugg(p.name.toLowerCase())).join('/');

export const product = function product(
  id,
  name,
  paths = [{ name: 'Missing Paths', id: 'missing' }]
) {
  return `/${slugifyPaths(paths)}/${slugg(name.toLowerCase())}--p${id}`;
};

product.pattern = '*--p:id';
product.isMatch = isMatch;

export const category = function category(
  id,
  name,
  paths = [{ name: 'Missing Paths', id: 'missing' }]
) {
  return `/${slugifyPaths(paths)}/${slugg(name.toLowerCase())}--c${id}`;
};

category.pattern = '*--c:id';
category.isMatch = isMatch;

export const search = function search(query, pathname) {
  return `${pathname}?search=${encodeURIComponent(query)}`;
};

search.pattern = '*';
search.isMatch = function isMatchSearch(location) {
  const query =
    typeof location === 'string' ? location.split('?')[1] : location.search;

  return /search=/.test(query);
};

export const fullSearch = function fullSearch(query) {
  return `/search/${encodeURIComponent(query)}`;
};

fullSearch.pattern = '/search/:query';
fullSearch.isMatch = isMatch;

export const store = function store(id) {
  return `/--s${id}`;
};

store.pattern = '*--s:id';
store.isMatch = isMatch;
